const CreatePassword = () => import('@/modules/userPassword/index.vue');

export default [
  {
    name: 'create.password',
    path: '/criar-senha',
    meta: {
      isPublic: true,
      showSidebar: false,
    },
    component: CreatePassword,
  },
];
